export default "skymp5-front/53f34b25a515fd43fc70795783c4cb72.png";